import FavoriteIcon from "@mui/icons-material/Favorite";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import page2_section1 from "../../../assets/images/AboutVedaz/page2_section1.jpg";
import page2_section3 from "../../../assets/images/AboutVedaz/page2_section3.jpg";
import page2_section4 from "../../../assets/images/AboutVedaz/page2_section4.jpg";
import page2_section5 from "../../../assets/images/AboutVedaz/page2_section5.jpg";
import classes from "../AboutVedaz.styles";

interface Props {
  chapterIndex: number;
}

const AboutApp = ({ chapterIndex }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      {/* ── Section 1: Background image with glass card ───────────── */}
      <Box sx={classes.bgSection}>
        <Box component="img" src={page2_section1} alt="" sx={classes.bgSectionMedia} />
        <Box sx={classes.bgSectionOverlay} />
        <Box sx={classes.bgSectionContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_app_s1_heading")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "400px", mb: 0 }}>
            {t("about_app_s1_body")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 2: Plain section with heart icon ──────────────── */}
      <Box sx={classes.plainSection}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            mb: 2,
            position: "relative",
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              background: "rgba(244,67,54,0.15)",
              border: "1px solid rgba(244,67,54,0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              boxShadow: "0 0 20px rgba(244,67,54,0.2)",
            }}
          >
            <FavoriteIcon sx={{ color: "#F44336", fontSize: "20px" }} />
          </Box>
          <Typography sx={classes.sectionHeading} style={{ marginBottom: 0 }}>
            {t("about_app_s2_heading")}
          </Typography>
        </Box>
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <Typography sx={classes.bodyText}>{t("about_app_s2_body1")}</Typography>
          <Typography sx={{ ...classes.bodyText, mb: 0 }}>
            {t("about_app_s2_body2")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 3a: Number Theory — image left, content right ── */}
      <Box sx={classes.sideRow}>
        <Box sx={classes.sideImage}>
          <img src={page2_section3} alt={t("about_app_s3a_heading")} />
        </Box>
        <Box sx={classes.sideContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_app_s3a_heading")}
          </Typography>
          <Typography sx={classes.bodyText}>{t("about_app_s3a_body1")}</Typography>
          <Typography sx={classes.bodyText}>{t("about_app_s3a_body2")}</Typography>
          <Typography sx={{ ...classes.bodyText, mb: 0 }}>
            {t("about_app_s3a_body3")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 3b: Birth Chart — content left, image right ──── */}
      <Box sx={classes.sideRowReverse}>
        <Box sx={classes.sideImage}>
          <img src={page2_section4} alt={t("about_app_s3b_heading")} />
        </Box>
        <Box sx={classes.sideContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_app_s3b_heading")}
          </Typography>
          <Typography sx={classes.bodyText}>{t("about_app_s3b_body1")}</Typography>
          <Typography sx={classes.bodyText}>{t("about_app_s3b_body2")}</Typography>
          <Typography sx={{ ...classes.bodyText, mb: 0 }}>
            {t("about_app_s3b_body3")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 3c: Vedaz Algorithms — image left, content right */}
      <Box sx={classes.sideRow}>
        <Box sx={classes.sideImage}>
          <img src={page2_section5} alt={t("about_app_s3c_heading")} />
        </Box>
        <Box sx={classes.sideContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_app_s3c_heading")}
          </Typography>
          <Typography sx={classes.bodyText}>{t("about_app_s3c_body1")}</Typography>
          <Typography sx={classes.bodyText}>{t("about_app_s3c_body2")}</Typography>
          {[
            t("about_app_s3c_bullet1"),
            t("about_app_s3c_bullet2"),
            t("about_app_s3c_bullet3"),
            t("about_app_s3c_bullet4"),
          ].map((bullet, i) => (
            <Box key={i} sx={classes.bulletRow}>
              <Box sx={classes.bulletBadge}>
                <Box sx={classes.bulletDot} />
              </Box>
              <Typography sx={classes.bulletText}>{bullet}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default AboutApp;
